<template>
    <div class="myCertificate">
        <div class="bannerContent">

            <div class="scrollContent" :style="scrolling()">
                <div v-for="item in list" ref="items">
                    <el-image
                            style="height: 100%"
                            :src="item"
                            :preview-src-list="list">
                    </el-image>
                </div>
                <div v-for="item in list">
                    <el-image
                            style="height: 100%"
                            :src="item"
                            :preview-src-list="list">
                    </el-image>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
let interval = null

export default {
    name: 'myCertificate',
    methods: {
        scrolling: function () {
            let style = {
                width: this.width * 2 + 'px'
            }
            if (this.width) {
                style.animation = 'scroll 60s linear infinite'
                return style
            }
            return {}
        }
    },
    computed: {
        maxWidth: function () {
            let total = 0
            for (let item of this.$refs.items) {
                total += item.clientWidth + 20
            }
            return total
        }
    },
    data() {
        return {
            width: 0,
            show: null,
            list: [
                require('../../assets/certificate/编组 2@2x.png'),
                require('../../assets/certificate/编组 4@2x.png'),
                require('../../assets/certificate/编组@2x.png'),
                require('../../assets/certificate/编组 16@2x.png'),
                require('../../assets/certificate/编组 17@2x.png'),
                require('../../assets/certificate/编组 3@2x.png'),
                require('../../assets/certificate/编组 6@2x.png'),
                require('../../assets/certificate/编组 7@2x.png'),
                require('../../assets/certificate/编组 15@2x.png'),
                require('../../assets/certificate/编组 8@2x.png'),
                require('../../assets/certificate/编组 9@2x.png'),
                require('../../assets/certificate/编组 10@2x.png'),
                require('../../assets/certificate/编组 5@2x.png'),
                require('../../assets/certificate/编组 11@2x.png'),
                require('../../assets/certificate/编组 12@2x.png'),
            ]
        }
    },
    mounted() {
        this.$forceUpdate()
        setInterval(() => {
            if (this.maxWidth > 0) {
                this.width = this.maxWidth
                console.log(this.maxWidth)
            }
        }, 1000)
    },
    destroyed() {
        clearInterval(interval)
    }
}
</script>

<style scoped>
.bannerContent * {
    box-sizing: border-box;
}

.bannerContent {
    width: 1200px;
    margin: auto;
    overflow: hidden;
}

.scrollContent {
    animation-delay: 2s;
    display: flex;
    opacity: 0;
}

.scrollContent > div {
    height: 200px;
    margin: 0 10px;
}

</style>
<style>
@keyframes scroll {
    from {
        opacity: 1;
        transform: translateX(0);
    }
    to {
        opacity: 1;
        transform: translateX(-50%);
    }
}

.myCertificate img {
    width: auto !important;
}

.el-image-viewer__img {
    margin: auto !important;
}
</style>
